import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const GroupOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M7 13.67c1.28 0 2.33 1.04 2.33 2.33S8.29 18.33 7 18.33 4.67 17.29 4.67 16 5.71 13.67 7 13.67Zm0-1.6a3.93 3.93 0 1 0 .001 7.861A3.93 3.93 0 0 0 7 12.07ZM12 4.67c1.28 0 2.33 1.04 2.33 2.33S13.29 9.33 12 9.33 9.67 8.29 9.67 7 10.71 4.67 12 4.67Zm0-1.6a3.93 3.93 0 1 0 .001 7.861A3.93 3.93 0 0 0 12 3.07ZM17 13.67c1.28 0 2.33 1.04 2.33 2.33s-1.04 2.33-2.33 2.33-2.33-1.04-2.33-2.33 1.04-2.33 2.33-2.33Zm0-1.6a3.93 3.93 0 1 0 .001 7.861A3.93 3.93 0 0 0 17 12.07Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default GroupOutlined
